// extracted by mini-css-extract-plugin
module.exports = {"cartbutton":"CartButton_cartbutton__33r2k","bumps":"CartButton_bumps__2MbB_","bump":"CartButton_bump__1i_qf"};